import { Eleve } from '@teetsh/app/src/types/eleves';
import { matchSorter } from 'match-sorter';

export function matchEleve(
  givenName: string,
  familyName: string,
  eleves: Eleve[],
): Eleve {
  const matchByFamilyName = matchSorter(eleves, familyName.trim(), {
    keys: ['familyName'],
    threshold: matchSorter.rankings.MATCHES,
  });
  return matchSorter(matchByFamilyName, givenName.trim(), {
    keys: ['givenName'],
  })[0];
}
